import { formatBook } from "../../../utils/formatOdds";
// BetTableTeenPatti2 — 2 Cards Teenpatti (casino/patti2) bet table in the reference admin markup
// (tablet template, rendered inside .casino-table.teenpatti2cards > .casino-detail):
//   .d-none-small > .teen1daycasino-container (.teen1dayleft / .teen1daycenter / .teen1dayright:
//     Player X [back/lay], Mini Baccarat X [back, full], Total X [lay/back with bhav])
//   + .teenpatti2cardsextra.mt-3 (Color Plus + its book)
// Styled by the ported reference style.css (styles/index.css) + styles/games/patti2.css.

const EMPTY = { b: 0, l: 0, bbhav: 0, lbhav: 0, gstatus: "SUSPENDED" };

const normalize = (str) => String(str || "").replace(/\s+/g, " ").trim().toLowerCase();

const bySr = (a, b) => (Number(a?.sr) || 0) - (Number(b?.sr) || 0);

export default function BetTableTeenPatti2({ data = [], onBetClick, exposures = {}, myBets = [] }) {
  const sub = Array.isArray(data) ? data : [];
  const ofType = (type) => sub.filter((item) => normalize(item?.subtype) === type).sort(bySr);
  const main = ofType("patti2");
  const total = ofType("total");
  const baccarat = ofType("baccarat");
  const plus = ofType("plus");
  const pick = (list, i) => list[i] || EMPTY;
  // Total main price: 0 reads "-", like the reference
  const dash = (v) => (Number(v) ? v : "-");

  // Book value for a selection: exposures map (API) first, then My Bets exposure.
  const getExposure = (selection) => {
    if (!selection) return 0;
    const target = normalize(selection);
    for (const key of [selection, selection.trim(), target]) {
      const v = parseFloat(exposures[key]);
      if (!isNaN(v) && v !== 0) return v;
    }
    for (const key in exposures) {
      if (normalize(key) === target) {
        const v = parseFloat(exposures[key]);
        if (!isNaN(v) && v !== 0) return v;
      }
    }
    const bet = myBets.find((b) => normalize(b.selection || b.matchedBet || b.player_name) === target);
    const v = parseFloat(bet?.exposer);
    return !isNaN(v) ? v : 0;
  };

  // Reference v-casinobook / v-casinofancybook: > 0 → book-green, otherwise book-red (0 shown as "0")
  const book = (selection, className = "mr-2") => {
    const n = getExposure(selection);
    return <span className={`${className ? `${className} ` : ""}${n > 0 ? "book-green" : "book-red"}`}>{formatBook(n)}</span>;
  };

  const isOpen = (item) => item?.gstatus === "OPEN";

  const cell = (item, kind, children, extraClass = "") => {
    const open = isOpen(item);
    const value = kind === "back" ? item?.b : item?.l;
    return (
      <div
        className={`${kind} casino-bl-box-item${extraClass}${open ? "" : " suspended"}`}
        onClick={() => open && value && onBetClick?.(value, item?.nat, item, kind)}
      >
        {children}
      </div>
    );
  };

  const playerRow = (item, label) => (
    <div className="casino-box-row">
      <div className="casino-nation-name">
        <b>{label}</b>{" "}
        <div className="float-right">
          {book(item?.nat || label)}
        </div>
      </div>{" "}
      <div className="casino-bl-box">
        {cell(item, "back", <span className="casino-box-odd">{item?.b}</span>)}{" "}
        {cell(item, "lay", <span className="casino-box-odd">{item?.l}</span>)}
      </div>
    </div>
  );

  const baccaratRow = (item, label) => (
    <div className="casino-box-row">
      <div className="casino-nation-name">
        <b>{label}</b>{" "}
        <div className="float-right">
          {book(item?.nat || label)}
        </div>
      </div>{" "}
      <div className="casino-bl-box casino-bl-boxfull">
        {cell(item, "back", <span className="casino-box-odd">{item?.b}</span>)}
      </div>
    </div>
  );

  const totalRow = (item, label) => (
    <div className="casino-box-row">
      <div className="casino-nation-name">
        <b className="pointer">{label}</b>{" "}
        <div className="float-right">
          {book(item?.nat || label)}
        </div>
      </div>{" "}
      <div className="casino-bl-box total-odds">
        {cell(
          item,
          "lay",
          <>
            <span>{item?.lbhav}</span> <span className="casino-box-odd">{dash(item?.l)}</span>
          </>
        )}{" "}
        {cell(
          item,
          "back",
          <>
            <span>{item?.bbhav}</span> <span className="casino-box-odd">{dash(item?.b)}</span>
          </>
        )}
      </div>
    </div>
  );

  const colorPlus = pick(plus, 0);

  return (
    <div className="d-none-small">
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">
          {playerRow(pick(main, 0), "Player A")}{" "}
          {baccaratRow(pick(baccarat, 0), "Mini Baccarat A")}{" "}
          {totalRow(pick(total, 0), "Total A")}
        </div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">
          {playerRow(pick(main, 1), "Player B")}{" "}
          {baccaratRow(pick(baccarat, 1), "Mini Baccarat B")}{" "}
          {totalRow(pick(total, 1), "Total B")}
        </div>
      </div>{" "}
      <div className="teenpatti2cardsextra mt-3">
        <div className="casino-bl-box casino-bl-boxfull">
          {cell(colorPlus, "back", <span className="casino-box-odd">Color Plus</span>)}
        </div>{" "}
        <div className="teenpatti2cardsextra-book">
          {book(colorPlus?.nat || "Color Plus", "")}
        </div>
      </div>
    </div>
  );
}
